export const AI_ASSISTANT_ROUTE_NAMES = {
  AGENT_BOTS: 'agent_bots',
  AGENT_BOTS_CSML_NEW: 'agent_bots_csml_new',
  AGENT_BOTS_CSML_EDIT: 'agent_bots_csml_edit',
  AGENT_BOTS_WEBHOOK_NEW: 'agent_bots_webhook_new',
  AGENT_BOTS_WEBHOOK_EDIT: 'agent_bots_webhook_edit',
  AGENT_BOTS_WEBHOOK_TRAIN: 'agent_bots_webhook_train',
  AGENT_BOTS_WEBHOOK_TRAIN_NOTEA: 'agent_bots_webhook_train_notea',
};
